// Ozow API URLs for different environments
export const OZOW_API_URL = "https://ozow-api-gateway.cryptosrvc-dev.com";
export const OZOW_API_PROD_URL = "https://ozow-integration.cryptosrvc.com";
export const OZOW_API_TDM_PROD_URL = "https://ozow-integration-tdmarkets.cryptosrvc.com";
